import {
  addEventListener,
  NetInfoState,
} from '@react-native-community/netinfo';

export interface NetworkStateSnapshot {
  isConnected: boolean | null;
  isInternetReachable: boolean | null;
  type: string | null;
}

const UNKNOWN_SNAPSHOT: NetworkStateSnapshot = {
  isConnected: null,
  isInternetReachable: null,
  type: null,
};

let currentSnapshot: NetworkStateSnapshot = UNKNOWN_SNAPSHOT;
let unsubscribe: (() => void) | null = null;

const toSnapshot = (state: NetInfoState): NetworkStateSnapshot => ({
  isConnected: state.isConnected,
  isInternetReachable: state.isInternetReachable,
  type: state.type,
});

/**
 * Subscribe to connectivity changes and keep a synchronous snapshot so callers
 * that cannot await (e.g. the global crash handler) can read the last known
 * network state. Event-driven, no timers. Safe to call more than once.
 */
export const startNetworkStateTracking = (): void => {
  if (unsubscribe) {
    return;
  }

  unsubscribe = addEventListener((state) => {
    currentSnapshot = toSnapshot(state);
  });
};

export const getNetworkStateSnapshot = (): NetworkStateSnapshot =>
  currentSnapshot;

export const resetNetworkStateTracking = (): void => {
  unsubscribe?.();
  unsubscribe = null;
  currentSnapshot = UNKNOWN_SNAPSHOT;
};
